<div class="filter filter--wide">
  <div class="filter__options">
    <div class="filter__option filter__option--radio" *ngFor="let period of periods">
      <input
        class="filter__radio"
        type="radio"
        value="{{ period }}"
        name="filterPeriod"
        (change)="onRadioChecked($event.target.value)"
        [checked]="isRadioChecked(period) | async"
      />
      {{ period }}
    </div>
  </div>
  <div class="filter__option filter__option--radio">
    <input
      class="filter__radio"
      type="radio"
      value="Custom"
      name="filterPeriod"
      (change)="onRadioChecked($event.target.value)"
    />
    Custom
  </div>
  <div class="filter__options datepicker">
    <div class="datepicker__wrapper">
      <label class="datepicker__label">From</label>
      <input
        class="datepicker__input"
        matInput
        readonly
        placeholder="dd/mm/yyyy"
        [max]="endDate"
        [matDatepicker]="startDatePicker"
        [disabled]="(isCustomChecked$ | async) === false"
        (click)="openDatepicker(startDatePicker, startDatepicker)"
        (dateChange)="onStartDateChange($event)"
      />
      <mat-datepicker
        #startDatePicker
        panelClass="cell-datepicker ag-custom-component-popup"
        [calendarHeaderComponent]="datepickerHeaderComponent"
      ></mat-datepicker>
    </div>

    <div class="datepicker__wrapper">
      <label class="datepicker__label">To</label>
      <input
        class="datepicker__input"
        matInput
        readonly
        placeholder="dd/mm/yyyy"
        [min]="startDate"
        [matDatepicker]="endDatePicker"
        [disabled]="(isCustomChecked$ | async) === false"
        (click)="openDatepicker(endDatePicker, endDatepicker)"
        (dateChange)="onEndDateChange($event)"
      />
      <mat-datepicker
        #endDatePicker
        panelClass="cell-datepicker ag-custom-component-popup"
        [calendarHeaderComponent]="datepickerHeaderComponent"
      ></mat-datepicker>
    </div>
  </div>
</div>
